<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="650px" :destroy-on-close="true" append-to-body :before-close="cancel">
    <div class="el-dialog-div">
      <div v-for="(reminder,index) in reminders" :key="'reminder'+index">
        <el-descriptions class="margin-top" :column="1" border v-if="!reminder.remindersTimes[time] && reminder.doneFlag === 0"
                         :label-style="{ width: '100px' }" style="width: 580px">
          <template slot="extra">
            <el-button type="primary" size="small" @click="complete(reminder.id,reminder.remindersTimes,time)">完成</el-button>
            <el-button type="primary" size="small" @click="completeAll(reminder.id)">完成所有</el-button>
          </template>
          <el-descriptions-item label="标题">{{reminder.title}}</el-descriptions-item>
          <el-descriptions-item label="发票ID" v-if="reminder.invoiceInfoDTOS">
            <div class="invoice-list">
              <div v-for="(invoice, index1) in reminder.invoiceInfoDTOS"
                   :key="'reminder' + index + '-invoice' + index1"
                   class="invoice-item">
                <el-tooltip content="前往开票" v-if="invoice.invoiceStatus === 'PENDING_INVOICE'" placement="top">
                  <el-link type="warning" @click="openTicketsDialog(invoice)">{{ invoice.id}}</el-link>
                  <span v-if="index1!==reminder.invoiceInfoDTOS.length-1">{{','}}</span>
                </el-tooltip>
                <el-tooltip content="查看发票信息详情" v-else placement="bottom" effect="light">
                  <el-link type="primary" @click="showTicketsDialog(invoice)">{{ invoice.id }}</el-link>
                  <span v-if="index1!==reminder.invoiceInfoDTOS.length-1">{{','}}</span>
                </el-tooltip>
              </div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="邮寄ID" v-if="reminder.mailInfoDTOS">
            <div class="invoice-list">
              <div v-for="(mail, index2) in reminder.mailInfoDTOS"
                   :key="'reminder' + index + '-invoice' + index2"
                   class="invoice-item">
                <el-tooltip content="前往补全快递信息" v-if="mail.mailFlag === 'SUBMITTED'" placement="top">
                  <el-link type="warning" @click="openMailDialog(mail.id)">{{ mail.id}}</el-link>
                  <span v-if="index2!==reminder.mailInfoDTOS.length-1">{{','}}</span>
                </el-tooltip>
                <el-tooltip content="查看邮寄信息详情" v-if="mail.mailFlag === 'MAILED'" placement="bottom" effect="light">
                  <el-link type="primary" @click="showMailDialog(mail.id)">{{ mail.id }}</el-link>
                  <span v-if="index2!==reminder.mailInfoDTOS.length-1">{{','}}</span>
                </el-tooltip>
              </div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="内容备注">{{reminder.remark}}</el-descriptions-item>
        </el-descriptions>
        <el-divider v-if="index !== reminders.length - 1"></el-divider>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small"  type="primary" class="title" @click="cancel">确定</el-button>
    </div>
    <mail-details v-if="showMailDetails" :show-dialog="showMailDetails" :select-detail="MailDetails" @submit="close1"></mail-details>
    <mail-detail v-if="showMail" :show-dialog="showMail" :select-detail="MailDetail" @submit="close4"></mail-detail>
    <tickets-detail v-if="showTicketsDetails" :show-dialog="showTicketsDetails" :select-detail="TicketsDetail" @submit="close2"></tickets-detail>
    <tickets-mail-detail v-if="ticketsMailDialog" :show-dialog="ticketsMailDialog" :select-detail="ticketsMail" @submit="closeTicketsMailDialog"></tickets-mail-detail>
    <tickets-details v-if="showTickets" :show-dialog="showTickets" :select-detail="TicketsDetails" @submit="close3"></tickets-details>
  </el-dialog>
</template>

<script>

import {getMailPage} from "@/api/dilivery/mail";
import MailDetails from "@/components/mail/MailDetails.vue";
import {editReminders} from "@/api/dilivery/reminder";
import TicketsDetail from "@/components/check/TicketsDetail.vue";
import {getTicketsPage} from "@/api/dilivery/tickets";
import TicketsDetails from "@/components/tickets/TicketsDetails.vue";
import MailDetail from "@/components/check/MailDetail.vue";
import TicketsMailDetail from "@/components/check/TicketsMailDetail.vue";

export default {
  name: "ReminderInfo",
  components: {TicketsMailDetail, MailDetail, TicketsDetails, TicketsDetail, MailDetails},
  props:['showDialog','selectDetail','time'],
  data(){
    return{
      title:'今日未完成事项',
      showMailDetails:false,
      MailDetails:'',
      showMail:false,
      MailDetail:'',
      showTicketsDetails:false,
      TicketsDetail:'',
      showTickets:false,
      TicketsDetails:'',
      ticketsMailDialog:false,
      ticketsMail: '',
      reminders:[
        {
          id:'',
          mailInfoId: '',
          invoiceInfoDTOS:[],
          mailInfoDTOS:[],
          title: '',
          remindersTimes:{},
          doneFlag:'',
          remark:''
        }
      ]
    }
  },
  watch:{
    'selectDetail':{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.reminders = newVal
        }
      },
      immediate:true
    },
  },
  mounted() {
  },
  methods:{
    cancel(){
      this.$emit('submit','cancel')
    },
    completeAll(id){
      let form = {
        id : id,
        doneFlag : 1
      }
      editReminders(form).then(res=>{
        if(res.code === 200){
          this.$messageUi.success('修改成功')
          this.$emit('complete','all')
        }
      }).catch(err=>{
        this.$messageUi.error('修改失败')
      })
    },
    complete(id,remindersTimes,time){
      let form = {
        id:id,
        remindersTimes: remindersTimes,
      }
      form.remindersTimes[time] = true
      editReminders(form).then(res=>{
        if(res.code === 200){
          this.$messageUi.success('修改成功')
          this.$emit('complete','one')
        }
      }).catch(err=>{
        this.$messageUi.error('修改失败')
      })
    },
    showMailDialog(mailID){
      let param = {}
      let data = {
        "query#id.EQ":mailID
      }
      getMailPage(param,data).then(res=>{
        if(res.code === 200){
          this.MailDetails = res.data.records[0]
          this.showMailDetails = true
        }
      }).catch(err => {
      })
    },
    openMailDialog(mailID){
      let param = {}
      let data = {
        "query#id.EQ":mailID
      }
      getMailPage(param,data).then(res=>{
        if(res.code === 200){
          this.MailDetail = res.data.records[0]
          this.showMail = true
        }
      }).catch(err => {
      })
    },
    async openTicketsDialog(invoice){
      let data = {
        "query#id.EQ":invoice.id
      }
      const res = await getTicketsPage({},data)
      if(res.code === 200){
        if(res.data.records[0]['mailInfoDTO'] && res.data.records[0]['mailInfoDTO'].mailFlag === 'SUBMITTED'){
          this.ticketsMail = res.data.records[0]
          this.ticketsMailDialog = true
        }else{
          this.TicketsDetail = res.data.records[0]
          this.showTicketsDetails = true
        }
      }else {
        this.$messageUi.error('获取发票信息失败')
      }
    },
    async showTicketsDialog(invoice){
      let data = {
        "query#id.EQ":invoice.id
      }
      const res = await getTicketsPage({},data)
      if(res.code === 200){
        this.TicketsDetails = res.data.records[0]
        this.showTickets = true
      }else {
        this.$messageUi.error('获取发票信息失败')
      }
    },
    close1(){
      this.showMailDetails = false
    },
    close2(){
      this.$emit('complete','one')
      this.showTicketsDetails = false
    },
    closeTicketsMailDialog() {
      this.ticketsMailDialog = false
      this.$emit('complete','one')
    },
    close3(){
      this.showTickets = false
    },
    close4(){
      this.$emit('complete','one')
      this.showMail = false
    }
  },
}
</script>

<style scoped>
.invoice-list {
  display: flex; /* 使用 flex 布局 */
  flex-wrap: nowrap; /* 防止子元素换行 */
  align-items: center; /* 垂直居中对齐 */
  overflow-x: auto; /* 水平滚动条，防止内容溢出 */
}

.invoice-item {
  margin-right: 10px; /* 设置每个发票项之间的间距 */
  white-space: nowrap; /* 防止内容换行 */
}

.invoice-item el-link {
  white-space: nowrap; /* 确保链接内容不换行 */
}
</style>

